<template>
  <!-- <h1 class="text-9xl text-center">{{ title }}</h1> -->
  <!-- <div style="height: 100%; width: 100%" v-loading="isLoading"> -->
  <router-view />
</template>

<script lang="ts" setup></script>
